import { render, staticRenderFns } from "./historyGo.vue?vue&type=template&id=1c59fd49&"
import script from "./historyGo.vue?vue&type=script&lang=js&"
export * from "./historyGo.vue?vue&type=script&lang=js&"
import style0 from "./historyGo.vue?vue&type=style&index=0&id=1c59fd49&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports